/**
 * @generated SignedSource<<d2ca64e120fc6e2ad06dece0a20cba01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type labelRow_labelCategory$data = {
  readonly allowOnTasks: boolean | null;
  readonly allowOnProjects: boolean | null;
  readonly allowOnPeople: boolean | null;
  readonly " $fragmentType": "labelRow_labelCategory";
};
export type labelRow_labelCategory$key = {
  readonly " $data"?: labelRow_labelCategory$data;
  readonly " $fragmentSpreads": FragmentRefs<"labelRow_labelCategory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "labelRow_labelCategory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowOnTasks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowOnProjects",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowOnPeople",
      "storageKey": null
    }
  ],
  "type": "LabelCategory",
  "abstractKey": null
};

(node as any).hash = "40b0356d0bbe4e399ce09f3f57cd8575";

export default node;
